/* Scandic — built-in collection filters & sorting (no app). Works on the cards rendered in the page. */
(function () {
  'use strict';
  const root = document.querySelector('[data-tf]');
  if (!root) return;

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const aside = $('#Facets');
  const groupsBox = $('[data-tf-groups]');
  const cards = $$('.coll-main [data-product-card]');
  const pageSize = parseInt(root.dataset.pageSize || 24, 10);
  const L = (k) => (aside && aside.dataset['l' + k.charAt(0).toUpperCase() + k.slice(1)]) || k;
  const cur = (aside && aside.dataset.currency) || '';
  const showCounts = aside && aside.dataset.showCounts !== 'false';
  const openCount = parseInt((aside && aside.dataset.open) || 3, 10);
  const order = ((aside && aside.dataset.groups) || 'availability, price, offer, type, vendor, options, tags')
    .split(',').map(s => s.trim().toLowerCase()).filter(Boolean);
  const esc = (s) => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const slug = (s) => String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

  /* ---- read product data from cards ---- */
  const items = cards.map((el, i) => {
    const d = el.dataset;
    const opts = {};
    (d.opts || '').split('||').filter(Boolean).forEach(pair => {
      const [n, v] = pair.split('::');
      if (!n || v === undefined) return;
      (opts[n] = opts[n] || new Set()).add(v);
    });
    const tags = {};
    (d.ftags || '').split('||').filter(Boolean).forEach(t => {
      const parts = t.split(':');
      const g = parts.length > 1 ? parts[0].trim() : 'Tags';
      const v = (parts.length > 1 ? parts.slice(1).join(':') : parts[0]).trim();
      if (v) (tags[g] = tags[g] || new Set()).add(v);
    });
    return {
      el, i, group: el.closest('.coll-group'),
      title: d.title || '', price: parseInt(d.price || 0, 10), available: d.available === 'true',
      type: d.type || '', vendor: d.vendor || '', created: parseInt(d.created || 0, 10),
      discount: parseInt(d.discount || 0, 10), rating: parseFloat(d.rating || 0) || 0, opts, tags
    };
  });
  if (!items.length) { if (aside) aside.hidden = true; $$('.facets-toggle').forEach(b => b.hidden = true); return; }

  /* ---- build group definitions ---- */
  const groups = [];
  const countBy = (fn) => { const m = new Map(); items.forEach(it => [].concat(fn(it)).forEach(v => { if (v !== '' && v != null) m.set(v, (m.get(v) || 0) + 1); })); return m; };
  const addList = (key, label, map, test) => { if (map.size < 1) return; groups.push({ key, label, type: 'list', values: [...map.entries()].sort((a, b) => String(a[0]).localeCompare(String(b[0]), undefined, { numeric: true })), test }); };

  order.forEach(g => {
    if (g === 'availability') {
      const m = new Map(); const inS = items.filter(i => i.available).length; const out = items.length - inS;
      if (inS) m.set(L('instock'), inS); if (out) m.set(L('outstock'), out);
      if (m.size > 1 || out) groups.push({ key: 'availability', label: L('availability'), type: 'list', values: [...m.entries()], test: (it, v) => (v === L('instock')) === it.available });
    } else if (g === 'price') {
      const prices = items.map(i => i.price);
      const min = Math.floor(Math.min(...prices) / 100), max = Math.ceil(Math.max(...prices) / 100);
      if (max > min) groups.push({ key: 'price', label: L('price'), type: 'price', min, max });
    } else if (g === 'offer') {
      const n = items.filter(i => i.discount > 0).length;
      if (n && n < items.length) groups.push({ key: 'offer', label: L('offer'), type: 'list', values: [[L('onsale'), n]], test: (it) => it.discount > 0 });
    } else if (g === 'type') {
      const m = countBy(i => i.type); if (m.size > 1) addList('type', L('type'), m, (it, v) => it.type === v);
    } else if (g === 'vendor') {
      const m = countBy(i => i.vendor); if (m.size > 1) addList('vendor', L('vendor'), m, (it, v) => it.vendor === v);
    } else if (g === 'options') {
      const names = new Set(); items.forEach(i => Object.keys(i.opts).forEach(n => names.add(n)));
      names.forEach(n => { const m = countBy(i => i.opts[n] ? [...i.opts[n]] : []); if (m.size > 1 || (m.size === 1 && [...m.values()][0] < items.length)) addList('o-' + slug(n), n, m, (it, v) => !!(it.opts[n] && it.opts[n].has(v))); });
    } else if (g === 'tags') {
      const names = new Set(); items.forEach(i => Object.keys(i.tags).forEach(n => names.add(n)));
      names.forEach(n => { const m = countBy(i => i.tags[n] ? [...i.tags[n]] : []); addList('t-' + slug(n), n, m, (it, v) => !!(it.tags[n] && it.tags[n].has(v))); });
    }
  });

  /* ---- state ---- */
  const state = { sel: {}, min: null, max: null, sort: 'featured', limit: pageSize };
  const params = new URLSearchParams(window.location.search);
  groups.forEach(g => {
    if (g.type === 'list') { const v = params.getAll('f_' + g.key); if (v.length) state.sel[g.key] = new Set(v); }
  });
  if (params.get('pmin')) state.min = parseInt(params.get('pmin'), 10);
  if (params.get('pmax')) state.max = parseInt(params.get('pmax'), 10);
  if (params.get('sort')) state.sort = params.get('sort');

  /* ---- render sidebar ---- */
  function renderGroups() {
    if (!groupsBox) return;
    groupsBox.innerHTML = groups.map((g, gi) => {
      const active = g.type === 'list' ? (state.sel[g.key] ? state.sel[g.key].size : 0) : ((state.min != null || state.max != null) ? 1 : 0);
      const open = gi < openCount || active ? ' open' : '';
      let body = '';
      if (g.type === 'price') {
        body = `<div class="facet__price">
          <label><span>${esc(cur)}</span><input type="number" inputmode="numeric" min="${g.min}" max="${g.max}" placeholder="${g.min}" value="${state.min ?? ''}" data-tf-min aria-label="${esc(g.label)} min"></label>
          <span class="facet__dash">–</span>
          <label><span>${esc(cur)}</span><input type="number" inputmode="numeric" min="${g.min}" max="${g.max}" placeholder="${g.max}" value="${state.max ?? ''}" data-tf-max aria-label="${esc(g.label)} max"></label>
        </div>
        <div class="facet__range"><input type="range" min="${g.min}" max="${g.max}" value="${state.max ?? g.max}" data-tf-range aria-label="${esc(g.label)}"></div>`;
      } else {
        body = '<ul class="facet__list">' + g.values.map(([v, n], vi) => {
          const id = `tf-${g.key}-${vi}`; const on = state.sel[g.key] && state.sel[g.key].has(String(v));
          return `<li><label for="${id}" class="facet__opt"><input type="checkbox" id="${id}" data-tf-group="${esc(g.key)}" value="${esc(v)}"${on ? ' checked' : ''}>
            <span class="facet__box"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg></span>
            <span class="facet__label">${esc(v)}</span>${showCounts ? `<span class="facet__num" data-tf-num="${esc(g.key)}::${esc(v)}">(${n})</span>` : ''}</label></li>`;
        }).join('') + '</ul>';
      }
      return `<details class="facet"${open}><summary class="facet__summary"><span>${esc(g.label)}${active ? ` <span class="facet__count">${active}</span>` : ''}</span>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="m6 9 6 6 6-6"/></svg></summary>${body}</details>`;
    }).join('');
  }

  /* ---- filtering ---- */
  const matches = (it, skipKey) => {
    for (const g of groups) {
      if (g.key === skipKey) continue;
      if (g.type === 'list') {
        const sel = state.sel[g.key];
        if (sel && sel.size && ![...sel].some(v => g.test(it, v))) return false;
      } else if (g.type === 'price') {
        const p = it.price / 100;
        if (state.min != null && p < state.min) return false;
        if (state.max != null && p > state.max) return false;
      }
    }
    return true;
  };

  const sorters = {
    featured: (a, b) => a.i - b.i,
    'price-asc': (a, b) => a.price - b.price || a.i - b.i,
    'price-desc': (a, b) => b.price - a.price || a.i - b.i,
    'discount-desc': (a, b) => b.discount - a.discount || a.i - b.i,
    'rating-desc': (a, b) => b.rating - a.rating || a.i - b.i,
    'title-asc': (a, b) => a.title.localeCompare(b.title),
    'title-desc': (a, b) => b.title.localeCompare(a.title),
    'created-desc': (a, b) => b.created - a.created || a.i - b.i
  };

  function apply(resetLimit) {
    if (resetLimit) state.limit = pageSize;
    const sorted = items.slice().sort(sorters[state.sort] || sorters.featured);
    // reorder within each grid
    const grids = new Map();
    sorted.forEach(it => { const g = it.el.parentElement; if (!grids.has(g)) grids.set(g, []); grids.get(g).push(it); });
    grids.forEach((list, g) => list.forEach(it => g.appendChild(it.el)));

    let shown = 0, total = 0;
    sorted.forEach(it => {
      const ok = matches(it);
      if (ok) total++;
      const visible = ok && shown < state.limit;
      if (visible) shown++;
      it.el.hidden = !visible;
    });
    $$('.coll-main .coll-group').forEach(g => { g.hidden = !$$('[data-product-card]', g).some(c => !c.hidden); });

    // counts per option (facet-aware)
    if (showCounts) groups.forEach(g => {
      if (g.type !== 'list') return;
      g.values.forEach(([v]) => {
        const n = items.filter(it => matches(it, g.key) && g.test(it, String(v))).length;
        const el = $(`[data-tf-num="${CSS.escape(g.key + '::' + v)}"]`);
        if (el) { el.textContent = `(${n})`; el.closest('.facet__opt').classList.toggle('is-disabled', n === 0 && !(state.sel[g.key] && state.sel[g.key].has(String(v)))); }
      });
    });

    const countEl = $('[data-tf-count]');
    if (countEl) countEl.textContent = (root.dataset.lResults || '__n__').replace('__n__', total);
    const empty = $('[data-tf-empty]'); if (empty) empty.hidden = total !== 0;
    const moreWrap = $('[data-tf-more-wrap]');
    if (moreWrap) {
      moreWrap.hidden = shown >= total;
      const prog = $('[data-tf-progress]'); if (prog) prog.textContent = (root.dataset.lShowing || '').replace('__s__', shown).replace('__t__', total);
      const bar = $('[data-tf-bar]'); if (bar) bar.style.width = (total ? (shown / total) * 100 : 0) + '%';
    }
    renderActive();
    syncUrl();
  }

  function renderActive() {
    const box = $('[data-tf-active]');
    let n = 0; const chips = [];
    groups.forEach(g => {
      if (g.type === 'list' && state.sel[g.key]) state.sel[g.key].forEach(v => { n++; chips.push(`<button type="button" class="chip active-chip" data-tf-remove="${esc(g.key)}" data-v="${esc(v)}">${esc(g.label)}: ${esc(v)} ×</button>`); });
      if (g.type === 'price' && (state.min != null || state.max != null)) { n++; chips.push(`<button type="button" class="chip active-chip" data-tf-remove="price">${esc(cur)}${state.min ?? g.min} – ${esc(cur)}${state.max ?? g.max} ×</button>`); }
    });
    if (box) { box.hidden = !n; box.innerHTML = chips.join('') + (n ? `<button type="button" class="active-filters__clear" data-tf-clear>${esc($('[data-tf-clear]') ? $('[data-tf-clear]').textContent : 'Clear')}</button>` : ''); }
    const badge = $('[data-tf-badge]'); if (badge) badge.textContent = n ? `(${n})` : '';
    // refresh summary counters
    $$('details.facet', groupsBox).forEach((d, gi) => {
      const g = groups[gi]; if (!g) return;
      const a = g.type === 'list' ? (state.sel[g.key] ? state.sel[g.key].size : 0) : ((state.min != null || state.max != null) ? 1 : 0);
      const span = $('summary > span', d); if (span) span.innerHTML = esc(g.label) + (a ? ` <span class="facet__count">${a}</span>` : '');
    });
  }

  function syncUrl() {
    const p = new URLSearchParams(window.location.search);
    [...p.keys()].filter(k => k.startsWith('f_') || ['pmin', 'pmax', 'sort'].includes(k)).forEach(k => p.delete(k));
    Object.entries(state.sel).forEach(([k, set]) => set.forEach(v => p.append('f_' + k, v)));
    if (state.min != null) p.set('pmin', state.min);
    if (state.max != null) p.set('pmax', state.max);
    if (state.sort !== 'featured') p.set('sort', state.sort);
    const q = p.toString();
    history.replaceState(null, '', window.location.pathname + (q ? '?' + q : ''));
  }

  /* ---- events ---- */
  renderGroups();
  const sortSel = $('[data-tf-sort]');
  if (sortSel) { sortSel.value = sorters[state.sort] ? state.sort : 'featured'; sortSel.addEventListener('change', () => { state.sort = sortSel.value; apply(true); }); }

  document.addEventListener('change', (e) => {
    const cb = e.target.closest('[data-tf-group]');
    if (cb) {
      const k = cb.dataset.tfGroup; state.sel[k] = state.sel[k] || new Set();
      cb.checked ? state.sel[k].add(cb.value) : state.sel[k].delete(cb.value);
      if (!state.sel[k].size) delete state.sel[k];
      apply(true); return;
    }
    if (e.target.matches('[data-tf-min],[data-tf-max]')) {
      const mn = $('[data-tf-min]').value, mx = $('[data-tf-max]').value;
      state.min = mn === '' ? null : Math.max(0, parseInt(mn, 10));
      state.max = mx === '' ? null : parseInt(mx, 10);
      if (state.min != null && state.max != null && state.min > state.max) [state.min, state.max] = [state.max, state.min];
      const r = $('[data-tf-range]'); if (r && state.max != null) r.value = state.max;
      apply(true);
    }
  });
  let rt;
  document.addEventListener('input', (e) => {
    if (!e.target.matches('[data-tf-range]')) return;
    const mx = $('[data-tf-max]'); if (mx) mx.value = e.target.value;
    clearTimeout(rt); rt = setTimeout(() => { state.max = parseInt(e.target.value, 10); apply(true); }, 150);
  });
  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-tf-remove]');
    if (rm) {
      const k = rm.dataset.tfRemove;
      if (k === 'price') { state.min = state.max = null; }
      else if (state.sel[k]) { state.sel[k].delete(rm.dataset.v); if (!state.sel[k].size) delete state.sel[k]; }
      renderGroups(); apply(true); return;
    }
    if (e.target.closest('[data-tf-clear]')) { state.sel = {}; state.min = state.max = null; renderGroups(); apply(true); return; }
    if (e.target.closest('[data-tf-more]')) { state.limit += pageSize; apply(false); }
  });

  apply(false);
})();
